/**
 * Ported from legacy ui-loading-view.ts
 */

import { css, html, LitElement, type TemplateResult } from "lit";
import { customElement } from "lit/decorators.js";
import { base } from "../../design-system/index.ts";
import "../dui/spinner/dui-spinner.ts";

const hostStyles = css`
  :host {
    display: block;
    width: 100%;
    height: 100%;
    container-type: size;
  }
`;

const componentStyles = css`
  .Loading {
    width: 100cqw;
    height: 100cqh;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

/**
 * `<loading-view>` — A full-size centered spinner for loading states.
 *
 * @csspart root - The outer container element.
 */
@customElement("loading-view")
export class LoadingViewElement extends LitElement {
  static override styles = [base, hostStyles, componentStyles];

  override render(): TemplateResult {
    return html`
      <div class="Loading" part="root">
        <dui-spinner size="lg"></dui-spinner>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "loading-view": LoadingViewElement;
  }
}
